import PostScreen from './components/PostScreen'

export default {
  path: '/noticias/:slug',
  name: 'Post',
  component: PostScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Post/index.js